export enum EmptyEntityType {
  Verify = 'Verify',
  Provider = 'Provider',
  Group = 'Group',
  Search = 'Search',
  Clear = 'Clear'
}
